import {createUseStyles} from 'react-jss';
import {Theme} from '../themes/default';

const useQuizStyles = createUseStyles((theme: Theme) => {
    return {
        quizContainer: {
            backgroundColor: theme.colors.espresso_brown,
            fontFamily: theme.fonts.apex,
            minHeight: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: theme.palette.primary.light,
            padding: `0 ${theme.spacing(2)}`,
        },
        quizContent: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            maxWidth: '900px',
        },
        titleSection: {
            textAlign: 'center',
            marginBottom: theme.spacing(10),
            marginTop: theme.spacing(4),
            fontSize: '2rem',
        },
        quizTitle: {
            margin: 0,
            fontFamily: theme.fonts.poplar,
            color: theme.palette.primary.light,
            textAlign: 'center',
            marginBottom: theme.spacing(1),
            fontSize: '3.3rem',
            textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
            [theme.breakpoints.down('md')]: {
                fontSize: '2rem',
            },
        },
        goldText: {
            color: theme.colors.desert_sand_gold,
        },
        subtitle: {
            color: theme.palette.primary.light,
            fontSize: '1.5rem',
            fontWeight: 'bold',
            marginTop: theme.spacing(3),
            opacity: 0.9,
        },
        questionIndicator: {
            marginBottom: theme.spacing(-3),
            zIndex: 2,
        },
        indicatorCircle: {
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            backgroundColor: theme.colors.desert_sand_gold,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '2rem',
            fontWeight: 'bold',
            color: theme.palette.primary.main,
            position: 'relative',
            zIndex: 2,
            marginTop: theme.spacing(-3),
        },
        questionContainer: {
            backgroundColor: theme.colors.espresso_brown,
            borderRadius: '15px',
            padding: theme.spacing(4),
            paddingTop: theme.spacing(6), 
            width: '90%',
            maxWidth: '600px',
            marginBottom: theme.spacing(4),
            backdropFilter: 'blur(10px)',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
            position: 'relative',
            zIndex: 1,
        },
        questionText: {
            color: theme.palette.primary.light,
            textAlign: 'center',
            marginBottom: theme.spacing(3),
            fontSize: '1.5rem',
            fontWeight: '500',
        },
        optionsContainer: {
            width: '100%',
        },
        radioGroup: {
            gap: theme.spacing(2),
        },
        optionLabel: {
            backgroundColor: theme.colors.dark_chocolate,
            borderRadius: '10px',
            padding: theme.spacing(1),
            margin: '0 !important',
            width: '100%',
            border: `2px solid ${theme.colors.latte_cream}`,
            transition: 'all 0.3s ease',
            '&:hover': {
                backgroundColor: theme.colors.espresso_brown,
                border: `2px solid ${theme.colors.latte_cream}`,
                transform: 'translateY(-2px)',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
            },
            '& .MuiFormControlLabel-label': {
                color: theme.palette.primary.light,
                fontSize: '1.1rem',
                fontWeight: '400',
                width: '100%',
                marginLeft: theme.spacing(1),
            },
        },
        radioButton: {
            color: theme.colors.golden_mustard,
        },
        nextButton: {
            backgroundColor: theme.colors.golden_mustard,
            color: theme.colors.espresso_brown,
            fontWeight: 'bold',
            fontSize: '0.8rem',
            padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
            borderRadius: '25px',
            marginTop: theme.spacing(3),
            alignSelf: 'center',
            boxShadow: '0 4px 15px rgba(212, 165, 116, 0.4)',
            transition: 'all 0.3s ease',
            '&:hover': {
                backgroundColor: theme.colors.desert_sand_gold,
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 20px rgba(212, 165, 116, 0.6)',
            },
        },
        progressContainer: {
            display: 'flex',
            gap: theme.spacing(5),
            alignItems: 'center',
        },
       progressCircle: {
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1.2rem',
            fontWeight: 'bold',
            border: `2px solid ${theme.colors.latte_cream}`,
            color: theme.palette.primary.light,
            backgroundColor: theme.colors.dark_chocolate,
            transition: 'all 0.3s ease',
            position: 'relative',
        },
        progressCurrent: {
            backgroundColor: theme.colors.desert_sand_gold,
            color: theme.colors.espresso_brown,
            border: `2px solid ${theme.colors.desert_sand_gold}`,
            boxShadow: '0 4px 15px rgba(212, 165, 116, 0.4)',
            transform: 'scale(1.1)',
        },
        progressCompleted: {
            backgroundColor: theme.colors.desert_sand_gold,
            color: theme.colors.espresso_brown,
            border: `2px solid ${theme.colors.desert_sand_gold}`,
            '&::after': {
                backgroundColor: theme.colors.desert_sand_gold,
            },
        },
        checkIcon: {
            fontSize: '1.5rem',
            color: theme.colors.espresso_brown,
        },
        dottedLine: {
            width: '95vw',
            height: '20px',
            background: `radial-gradient(circle, ${theme.colors.golden_mustard} 5px, transparent 2px)`,
            backgroundSize: '20px 20px',
            backgroundPosition: 'center',
            marginTop: theme.spacing(5),
            //marginBottom: theme.spacing(7),
        },

        productsContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: theme.spacing(20),
            //marginTop: theme.spacing(4),
            marginBottom: theme.spacing(6),
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'column',
                gap: theme.spacing(3),
                marginTop: theme.spacing(-5),
            },
        },
        productImage: {
            width: '400px',
            height: 'auto',
            transition: 'transform 0.3s ease',
            '&:hover': {
                transform: 'scale(1.05)',
            },
            [theme.breakpoints.down('md')]: {
                width: '200px',
            },
        },

        storesContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: theme.spacing(3),
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(6),
            [theme.breakpoints.down('md')]: {
                flexDirection: 'row',
                flexWrap: 'wrap',
                gap: theme.spacing(2),
                maxWidth: '350px',
            },
        },
        storeImage: {
            width: '300px',
            height: 'auto',
            transition: 'transform 0.3s ease',
            '&:hover': {
                transform: 'scale(1.1)',
            },
            [theme.breakpoints.down('md')]: {
                width: '150px',
                flex: '0 0 calc(50% - 8px)',
            },
        },
    };
});

export default useQuizStyles;